import { render, staticRenderFns } from "./PorFaixa.vue?vue&type=template&id=844a14a2&scoped=true&lang=pug&"
import script from "./PorFaixa.vue?vue&type=script&lang=js&"
export * from "./PorFaixa.vue?vue&type=script&lang=js&"
import style0 from "./PorFaixa.vue?vue&type=style&index=0&id=844a14a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844a14a2",
  null
  
)

export default component.exports